import { Selector, createSelector } from '@reduxjs/toolkit'
import { EntityType, IndexDetail, EntityStatus } from 'api'
import { GlobalState } from 'store'
import {
  createAllEntityUpdatesSelector,
  createAllEntitiesSelector,
  createSortedEntityIdsSelector,
  createEntityGetterSelector
} from './entitySelectors'
import { createUserNameByUserIdGetterSelector } from './userSelectors'

export const indexDetailsSelector: Selector<GlobalState, IndexDetail[]> = createSelector(
  [createAllEntityUpdatesSelector(EntityType.INDEX), createUserNameByUserIdGetterSelector],
  (indexUpdates, getUserNameFromUserId) => {
    return indexUpdates.map(update => {
      const index = update.entity
      const availableEvents = update.availableEvents
      const lastUpdatedByUserName = getUserNameFromUserId(index.lastUpdatedBy)
      return { index, availableEvents, lastUpdatedByUserName }
    })
  }
)

export const enabledIndexIdsSelector: Selector<GlobalState, String[]> = createSelector(
  [createSortedEntityIdsSelector(EntityType.INDEX), createEntityGetterSelector(EntityType.INDEX)],
  (indexIds, getIndex) => {
    return indexIds.filter(indexId => {
      const index = getIndex(indexId)
      return index?.status === EntityStatus.ENABLED
    })
  }
)

export const createLinkedCollateralsLengthGetterSelector: Selector<
  GlobalState,
  (indexId: string) => number
> = createSelector(createAllEntitiesSelector(EntityType.COLLATERAL), allCollaterals => (indexId: string) =>
  allCollaterals.filter(collateral => collateral.collateralIndexDetails?.indexId === indexId).length
)

export const indexByCodeGetterSelector = createSelector(createAllEntitiesSelector(EntityType.INDEX), allIndices => (code: string) =>
  allIndices.find(index => index.code === code) ?? null
)
